// extracted by mini-css-extract-plugin
export var phone = "_3o-0";
export var phoneDragging = "_3o-1";